import { render, staticRenderFns } from "./products.vue?vue&type=template&id=87672f18&scoped=true&lang=html&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&id=87672f18&lang=scss&scoped=true&"
import style1 from "./products.vue?vue&type=style&index=1&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87672f18",
  null
  
)

export default component.exports